import { defineComponent as _defineComponent } from 'vue'
interface InputLoginProps {
    placeholder?: string;
    value?: string;
    type?: string;
}

interface InputLoginEmits {
    (e: 'submit'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InputLogin',
  props: {
    placeholder: null,
    value: null,
    type: null
  },
  emits: ["submit"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'submit'): void
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit }
}

})